import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
// import registerServiceWorker from './registerServiceWorker';

import ResetPassword from './components/ResetPassword';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

ReactDOM.render(
    (
        <Router>
            <Switch>
                <Route path="/:token/:email" component={ResetPassword} />
            </Switch>
        </Router>
    )
    , document.getElementById('root'));

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js